import { Action, createReducer, on } from '@ngrx/store';
import { SciSistema } from '~models/maestros-sync/SciSistema';
import { cargarSistema, cargarSistemaSuccess } from '../actions/sistema.actions';

export interface SistemaState {
	sistema: SciSistema | null;
	loaded: boolean;
	loading: boolean;
	error: any;
}

export const accesosInitialState: SistemaState = {
	sistema: null,
	loaded: false,
	loading: false,
	error: null,
};

const _sistemaReducer = createReducer(
	accesosInitialState,

	on(cargarSistema, (state) => ({ ...state, loading: true })),

	on(cargarSistemaSuccess, (state, sistema) => ({
		...state,
		loading: false,
		loaded: true,
		sistema,
	}))
);

export function sistemaReducer(state: SistemaState | undefined, action: Action) {
	return _sistemaReducer(state, action);
}
